// extracted by mini-css-extract-plugin
module.exports = {"component":"configuration-flow-header_component__VEqgR","headline":"configuration-flow-header_headline__Twhae"};